import { useAuth } from 'react-oidc-context';
import {
  OrderStatusCode,
  RetryShipmentButtonProps,
} from '../interface/interface';
import { retryShipment } from '../service/retryShipment';
import showToast from './ToastComponent';

export function RetryShipmentButton({
  currentOrderStatus,
  orderId,
  setLoading,
  failureReason,
  hasDeletedShipment,
}: RetryShipmentButtonProps) {
  const { user } = useAuth();
  const addressValidationError = 'Address validation failed';

  if (!user?.access_token) return <></>;

  if (
    ![
      OrderStatusCode.DISPENSED,
      OrderStatusCode.READY_FOR_SHIPPING,
      OrderStatusCode.AUSPOST_FAILURE,
    ].includes(currentOrderStatus!) ||
    ([OrderStatusCode.DISPENSED, OrderStatusCode.READY_FOR_SHIPPING].includes(
      currentOrderStatus!,
    ) &&
      !hasDeletedShipment) ||
    (currentOrderStatus === OrderStatusCode.AUSPOST_FAILURE &&
      failureReason === addressValidationError)
  )
    return <></>;

  const retryShipmentHandler = async () => {
    setLoading(true);
    const responseStatus = await retryShipment(user.access_token, orderId);
    setLoading(false);
    if (responseStatus === 200) {
      showToast({
        message: 'Shipment created successfully',
        type: 'success',
      });
    } else {
      showToast({
        message: 'Failed to create shipment',
        type: 'error',
      });
    }
  };

  return (
    <button
      className="bg-secondary-green-100 text-primary-blue-500 p-3 
                2.5xl:px-6 2.5xl:py-3 text-sm 2.5xl:text-base font-semibold rounded mr-6"
      onClick={() => retryShipmentHandler()}
    >
      {hasDeletedShipment ? 'Create' : 'Retry'} Shipment
    </button>
  );
}
